<template>
  <v-row class="insurers-wrapper">
    <v-col>
      <v-row class="app-container--width-max mx-auto">
        <v-col cols="12" md="4">
          <h3 class="font-24">We love making your life</h3>
          <h1 class="font-lobster font-weight-regular">easier</h1>
        </v-col>
        <v-col cols="12" md="8">
          We strongly believe insurance is best purchased alongside professional
          advice and support. That's why you won't find us on comparison
          websites. Instead, we make our insurance available through a network
          of partners who work hard to understand your needs and are backed by
          some of the UK's most recognised insurers.
        </v-col>
        <v-col
          cols="12"
          class="d-flex flex-wrap justify-space-between pt-5 logo-wrapper align-center"
        >
          <div
            class="logo__item--wrapper"
            v-for="(insurer, index) in insurers"
            :key="index"
          >
            <div class="logo__item">
              <img
                :class="`logo-${insurer.name}`"
                :src="require(`@/assets/images/${insurer.url}`)"
                :alt="insurer.alt"
              />
            </div>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { INSURERS } from "@/constants/d2c-landing-page.constants";
export default {
  name: "LandingPageInsurers",
  props: {
    insurers: {
      type: Array,
      default: () => INSURERS,
    },
  },
};
</script>
<style lang="scss" scoped>
.insurers-wrapper {
  background: $black-2;
  color: #fff;
  padding: 20px 0 18px 0;

  .logo__item {
    display: inline-block;
    img {
      max-height: 35px;
    }
  }
}

@media screen and (max-width: $grid-breakpoints-lg - 1) {
  .insurers-wrapper {
    .col-md-4 {
      text-align: center;
    }
    .logo-wrapper {
      .logo__item {
        width: 33%;
        margin-bottom: 25px;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: space-around;
        img {
          max-width: 70%;
        }
        &:last-child {
          margin: auto;
        }
      }
    }
  }
}
</style>
